let RegionService = function (Restangular) {
  const Service = Restangular.all("admin/region");
  const RegionEvent = Restangular.all("v2/admin/events");

  const getSpecialHours = (id) => {
    return RegionEvent.get(`region/${id}`);
  };

  const createSpecialHours = (postBody, id) => {
    return postBody.id
      ? RegionEvent.customPUT(postBody, postBody.id)
      : RegionEvent.customPOST(postBody, `region/${id}`);
  };

  const deleteSpecialHours = (date) => {
    return Restangular.one(
      "v2/admin/special_hours",
      date.id
    ).remove();
  };

  let count = (query) => {
    query = query || {};
    query.deleted_at = "null";
    return Service.customGET("count", query);
  };

  let save = (resource) => {
    if (resource.save) {
      return resource.save();
    } else {
      return Service.post(resource);
    }
  };

  let index = (query) => {
    query = query || {};
    query.deleted_at = "null";
    return Service.getList(query);
  };

  let load = (query) => {
    query = query || {};
    query.deleted_at = "null";
    return new Promise((resolve, reject) => {
      count(query)
        .then((response) => {
          let count = response[0];
          index(query)
            .then((data) => {
              resolve({ count, data });
            })
            .catch((err) => {
              reject(err);
            });
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  let show = (id) => {
    return Service.get(id);
  };

  let destroy = (resource) => {
    resource.deleted_at = moment();
    return resource.save();
  };

  return {
    index,
    load,
    save,
    show,
    destroy,
    getSpecialHours,
    createSpecialHours,
    deleteSpecialHours,
  };
};

RegionService.$inject = ["Restangular"];

export default RegionService;



// WEBPACK FOOTER //
// ./client/app/components/region/region.service.js